import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  inject
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Guid } from "app/core/interfaces/guid.interface";
import { ButtonComponent } from "app/shared/components/button/button.component";
import { PagerComponent } from "app/shared/components/pager/pager.component";
import { NavigationSuggestionResolver } from "app/shared/route/navigation-suggestion-resolver.service";
import { HealthAPIService } from "app/shared/services/health-api/health-api.service";
import { SessionDataService } from "app/shared/services/session-data/session-data.service";
import { Subscription } from "rxjs";

import { AccountProfile } from "../../interfaces/profile/account-profile.interface";
import { OnboardingFinish } from "../../interfaces/profile/onboarding-finish.interface";

@Component({
  selector: "app-introduction",
  templateUrl: "./introduction.component.html",
  styleUrls: ["./introduction.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CommonModule, PagerComponent]
})
export class IntroductionComponent implements OnInit, OnDestroy {
  private healthAPI = inject(HealthAPIService);
  private navigationSuggestionResolver = inject(NavigationSuggestionResolver);
  private sessionData = inject(SessionDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  private sessionDataSubscription: Subscription | null = null;

  firstName = "deelnemer";
  lastProjectName = "deelname";

  welcomeVcheq: Guid;
  activePage = 1;
  lastPage = 5;

  constructor() {
    this.welcomeVcheq = this.sessionData.welcomeVcheq;
    this.lastProjectName = this.sessionData.lastProjectName;
  }

  ngOnInit() {
    this.getProfile();
    this.sessionDataSubscription = this.sessionData.changeEmitter.subscribe(
      (data) => {
        this.welcomeVcheq = data.welcomeVcheq;
        this.lastProjectName = data.lastProjectName;
      }
    );
  }

  public ngOnDestroy(): void {
    if (this.sessionDataSubscription) {
      this.sessionDataSubscription.unsubscribe();
    }
  }

  getProfile() {
    this.healthAPI.getProfile().subscribe((profile: AccountProfile) => {
      if (profile) {
        this.firstName = profile.firstName;
      }
    });
  }

  pageChange(page: number) {
    this.activePage = page;
  }

  pageForward() {
    if (this.activePage < this.lastPage) {
      this.activePage += 1;
    }
  }

  pageBack() {
    if (this.activePage > 1) {
      this.activePage += -1;
    }
  }

  finish() {
    const body: OnboardingFinish = {
      echeqFamily: this.welcomeVcheq.toString()
    };

    this.healthAPI.postOnboardingFinish(body).subscribe((i) => {
      //when vcheqFamily is empty Guid, empty response is returned
      if (i) {
        this.navigationSuggestionResolver.navigateToHint(i);
      } else {
        const fallbackUrl = this.route.snapshot.paramMap.get("fallbackUrl");
        if (fallbackUrl) {
          this.router.navigateByUrl(fallbackUrl);
        } else {
          this.router.navigateByUrl("/dashboard");
        }
      }
    });
  }

  iconClass(activePage: number) {
    const iconKey = "icon-" + activePage;
    return { [iconKey]: true };
  }
}
